<div class="lpr-source-select" data-testid="source-select">
  <fs-lpr-source-dropdown
    [providers$]="providers$"
    [lprSourceSelectService]="lprSourceSelectService"
    [shouldShowPartialMatches$]="shouldShowPartialMatches$"
    [isDisabled]="isDisabled"
    (providerSelectionChange)="onProviderSelectionChange($event)"
    (cameraModelSelectionChange)="onCameraModelSelectionChange($event)"
  ></fs-lpr-source-dropdown>

  <fs-lpr-source-partial-matches
    (partialMatchesDisplayChange)="onPartialMatchesDisplayChange($event)"
  ></fs-lpr-source-partial-matches>

  <fs-lpr-source-conflicts
    [providers$]="providers$"
    [providerSelectionChange$]="providerSelectionChange$"
    [lprSourceSelectService]="lprSourceSelectService"
    [shouldShowPartialMatches$]="shouldShowPartialMatches$"
  ></fs-lpr-source-conflicts>
</div>
